import {
    Button,
    Container,
    Group,
    Text
} from "@mantine/core"

export const DataTableTokenPagination = (props: {
    totalCount: string,
    nextToken: string | null,
    handleLoadMore: () => void
}) => {

    const nextToken = props.nextToken;


    return (
        <Group>
            <Text>Total Records: {props.totalCount}</Text>
            <Container>
                {nextToken !== null ? <Button onClick={(e) => {
                    e.preventDefault();
                    props.handleLoadMore();
                }}>Load More</Button> : <Button variant={'outline'} disabled={true}>All records loaded</Button>}
            </Container>


        </Group>
    )
}
